import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import SectionsList from '../../../../../../../components/SectionsList'
import AdCreativeTagSection from './AdCreativeTagSection'
import AdQuarantineField from '../../../../../../ReusableFormFields/AdQuarantineField'

import { initialAdCreativeTag } from '../../Routes/ThirdPartyCreativesTagsRoute/fields'
import { AD_CREATIVES } from '../../../../fields'

const AdCreativeTagsFieldsStep = ({ formik, lineItemType }) => {
  const { values } = formik

  const allowDeleteAdCreative = useMemo(() => values[AD_CREATIVES].length > 1, [values])

  const sectionProps = useMemo(
    () => ({
      lineItemType
    }),
    [lineItemType]
  )

  return (
    <Step stepTitle="Third Party Creative Tags">
      <SectionsList
        formik={formik}
        fieldPath={AD_CREATIVES}
        allowAddAnotherSection={true}
        allowDeleteSection={allowDeleteAdCreative}
        addFirstSectionText={'Add creative'}
        addAnotherSectionText={'Add another creative'}
        Section={AdCreativeTagSection}
        initialSection={initialAdCreativeTag}
        sectionProps={sectionProps}
      />
      <AdQuarantineField formik={formik} />
    </Step>
  )
}

AdCreativeTagsFieldsStep.propTypes = {
  formik: PropTypes.object.isRequired,
  lineItemType: PropTypes.string.isRequired
}

export default AdCreativeTagsFieldsStep
